<template>
  <vs-popup
    class="product-order-pdf-popup"
    id="popup"
    title="DELIVERY NOTE"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow class="pdf-container">
      <div class="pdf-wrapper">
        <pdf ref="deliveryNotePdfComponent" :src="file" class="pdf-viewer"></pdf>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-4">
        <vs-button
          @click="onClickDownload"
          button="submit"
          icon-pack="feather"
          icon="icon-download-cloud"
          color="primary"
          class="ml-auto mt-2"
        >
          Download
        </vs-button>
        <vs-button @click="onClickSendEmail" button="submit" icon-pack="feather" icon="icon-send" color="warning" class="ml-2 mt-2">Send</vs-button>
      </div>
    </vx-card>
    <vs-prompt
      @cancel="customer_email=''"
      @accept="generateReport"
      @close="activePrompt = false"
      :title="'Select customer user email to send'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select
          :clearable="true" name="customerId" placeholder=""
          v-model="customer_email"
          label="email"
          :options="customer_list"
          :reduce="option => option.email"
          :dir="$vs.rtl ? 'rtl' : 'ltr'">
          <template v-slot:option="option">
              <span>{{option.email}} ( {{option.job_title || 'N/A'}} ) </span>
          </template>
          </v-select>
      </div>
    </vs-prompt>
  </vs-popup>
  
</template>

<script>
import pdf from "vue-pdf";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const CourierRepository = RepositoryFactory.get('courier')
const DropDownRepository = RepositoryFactory.get('drop_down')
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
import vSelect from 'vue-select'


function initialState() {
  return {
    open: false,
    id: "",
    file: "",
    customer_email: "",
    activePrompt: false,
    customer_list: [],
    customer_id: ''
  };
}

export default {
  name: "SalesQuotePrintView",
  data() {
    return initialState();
  },
  methods: {
    async onClickDownload() {
      window.open(this.file);
    },
    async openPopup(id, customer_id) {
      try {
        await Object.assign(this.$data, initialState());
        this.id = id;
        this.customer_id = customer_id
        await this.getDeliveryNotePdf();
        this.open = true;
      } catch (error) {
        //
      }
    },
    async getDeliveryNotePdf() {
      this.$vs.loading();
      try {
        CourierRepository.getDeliveryNotePdf(this.id).then((response) => {
          const file = new Blob([response.data], { type: "application/pdf" });
          this.file = URL.createObjectURL(file);
          this.open = true;
          this.$vs.loading.close();
        });
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    async onClickSendEmail() {
     try {
          const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.customer_id)).data
          this.customer_list = data
        } catch (e) {
          
        }
        this.open = false
        this.activePrompt = true
    },
    async generateReport() {
        this.open = true
        this.activePrompt = false
        this.$vs.loading()
        try {
          await CourierRepository.sendShipmentDocument(this.id, { user_email: this.customer_email})
          this.open = false
          this.showSuccessMessage('Delivery note sent successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }

        this.$vs.loading.close()
      },
  },
  components: {
    pdf,
     'v-select': vSelect
  },
  mixins: [SuccessMessage, ErrorMessages],
};
</script>

<style scoped>
.pdf-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}

.pdf-wrapper {
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
